const clientImages = {
    abb: require('../assets/clients/abb.png'),
    acer: require('../assets/clients/acer.png'),
    adani: require('../assets/clients/adani.png'),
    aditya: require('../assets/clients/aditya.jpg'),
    agrawal: require('../assets/clients/agrawal.png'),
    auro: require('../assets/clients/auro.png'),
    baker: require('../assets/clients/baker.png'),
    balaji: require('../assets/clients/balaji.png'),
    bauerengineeringindia: require('../assets/clients/bauer-engineering-india.svg').default,
    Bekham: require('../assets/clients/Bekham.png'),
    bhel: require('../assets/clients/bhel.png'),
    bpl: require('../assets/clients/bpl.jpg'),
    cairn: require('../assets/clients/cairn.png'),
    chetna: require('../assets/clients/chetna.png'),
    companies: require('../assets/clients/companies.xlsx'),
    coromonal: require('../assets/clients/coromonal.png'),
    dalmiacement: require('../assets/clients/dalmiacement.svg').default,
    deccan: require('../assets/clients/deccan.png'),
    deep: require('../assets/clients/deep.png'),
    dr: require('../assets/clients/dr.py'),
    enmas: require('../assets/clients/enmas.png'),
    expro: require('../assets/clients/expro.svg').default,
    FABTECH: require('../assets/clients/FABTECH.png'),
    Geodis: require('../assets/clients/Geodis.svg').default,
    GVR_Logo: require('../assets/clients/GVR_Logo.png'),
    harshini: require('../assets/clients/harshini.jpg'),
    hblbatteries: require('../assets/clients/hbl-batteries.png'),
    hg: require('../assets/clients/hg.png'),
    icsa: require('../assets/clients/icsa.png'),
    ifgl: require('../assets/clients/ifgl.svg').default,
    ijm: require('../assets/clients/ijm.png'),
    indianbulls: require('../assets/clients/indianbulls.png'),
    intrach: require('../assets/clients/intrach.gif'),
    itcem: require('../assets/clients/itcem.jpg'),
    jindal: require('../assets/clients/jindal.svg').default,
    JRSteelLogo: require('../assets/clients/JR-Steel-Logo.png'),
    jsw: require('../assets/clients/jsw.png'),
    keller: require('../assets/clients/keller.svg').default,
    lt: require('../assets/clients/lt.webp'),
    maha: require('../assets/clients/maha.jpg'),
    mahainfra: require('../assets/clients/mahainfra.png'),
    mahanthi: require('../assets/clients/mahanthi.png'),
    mpr: require('../assets/clients/mpr.png'),
    nalco: require('../assets/clients/nalco.png'),
    nav: require('../assets/clients/nav.png'),
    ncl: require('../assets/clients/ncl.svg').default,
    nsEngLogo: require('../assets/clients/nsEngLogo.jpg.png'),
    nsepoxy: require('../assets/clients/nsepoxy.svg').default,
    ongc: require('../assets/clients/ongc.jpg'),
    paramount: require('../assets/clients/paramount.png'),
    patil: require('../assets/clients/patil.jpg'),
    pennar: require('../assets/clients/pennar.png'),
    pillogo: require('../assets/clients/pil-logo.png'),
    pncinfra: require('../assets/clients/pncinfra.png'),
    ramco: require('../assets/clients/ramco.jpg'),
    relianceindustriesltd: require('../assets/clients/reliance-industries-ltd.png'),
    rhi: require('../assets/clients/rhi.png'),
    SAIL_LOGO_NEW: require('../assets/clients/SAIL_LOGO_NEW.png'),
    sanghvi: require('../assets/clients/sanghvi.png'),
    smslogo: require('../assets/clients/smslogo.png'),
    swathi: require('../assets/clients/swathi.png'),
    tatasteellogo: require('../assets/clients/tata-steel-logo.png'),
    tatapro: require('../assets/clients/tatapro.png'),
    thermal: require('../assets/clients/thermal.jpg'),
    ultatech: require('../assets/clients/ultatech.png'),
    VAGLOGO3DHKS: require('../assets/clients/VAG LOGO 3D_HKS.svg').default,
    vishwa: require('../assets/clients/vishwa.png'),
    vizagsteel: require('../assets/clients/vizagsteel.jpg'),
    zetwerklogo: require('../assets/clients/zetwerk-logo@2x.png'),
};

export default clientImages;
